import axios from 'axios'
import { config } from '../../Utils'
import { BackendTokenAPI } from '../../../../shared/api/backend'
import { Report } from '../CreateReport'

export const getKenDetailsViaInput = async (params: any) => {
  console.log('params', params)
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    params.isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
  )

  const data = await axios.post(
    config.API_PATH + '/ken',
    { type: params.type, search_term: params.search_term },
    {
      headers: {
        ...authHeader,
        'Content-Type': 'application/json',
      },
    },
  )

  console.log('input api', data)
  return { kens: data?.data || [] }
}

export const getKenDetailsViaUploadFile = async (body: any, isAdmin: boolean = false) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
  )

  const data = await axios.post(config.API_PATH + '/ken/upload', body, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  console.log('upload api', data)

  return { kens: data?.data?.kenDetails || [] }
}

export const createReportSetting = async (body: any, isAdmin: boolean = false) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
  )

  const data = await axios.post(config.API_PATH + '/settings', body, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  return data.data
}

export const createReport = async (request: Report) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(config.ADMIN_SCOPE)

  const data = await axios.post(config.API_PATH + '/report', request, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  return data.data
}

export const getTempCoverUploadUrl = async (
  params: {
    reportSettingName: string
    region: string
    contentType: string
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
  )

  const response = await axios.post(`${config.API_PATH}/store`, params, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const getReportSettingsList = async (
  params: {
    limit?: number
    offset?: number
  } = {},
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
  )

  const { limit = 10, offset = 0 } = params

  const response = await axios.get(config.API_PATH + '/settings', {
    params: {
      limit,
      offset,
    },
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  const responseBody = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
  console.log(responseBody)

  return {
    success: responseBody.success,
    message: responseBody.message,
    items: responseBody.data?.items || [],
    limit: responseBody.data?.limit || limit,
    offset: responseBody.data?.offset || offset,
    total: responseBody.data?.totalCount || 0,
  }
}
